function mapCognitoData(getCognitoDataUser) {
    if (getCognitoDataUser.data.getCognitoDataUser) {
        const cognitoData = getCognitoDataUser.data.getCognitoDataUser;
        return {
            // region: cognitoData.identity_pool_id ? cognitoData.identity_pool_id.split(':')[0] : '',
            identityPoolId: cognitoData.identity_pool_id,
            userPoolId: cognitoData.user_pool_id,
            userPoolClientId: cognitoData.cognito_client_id,
        };
    }
    return {};
}
export { mapCognitoData };
